<template>
    <div class="flex flex-col w-full">
        <div v-if="savedCartUrl.length > 0" class="my-4">
            Ссылка на корзину: <br />
            <div class="flex gap-1">
                {{savedCartUrl}} <IconCopy class="h-5 cursor-pointer" @click="copy(savedCartUrl)"></IconCopy>
            </div>
        </div>

        <SimpleButton
            class="w-full px-4 py-4 text-xs uppercase"
            type="button"
            theme="grey"
            @click="saveCart"
        >
            Поделиться корзиной
        </SimpleButton>
    </div>
</template>

<script setup lang="ts">
import MyToast from '~/components/MyToast.vue'
import MyToastError from '~/components/MyToastError.vue'
import { useToast } from 'vue-toastification'

const toast = useToast()
const privateAxios = usePrivateAxiosInstance()
const savedCartUrl = ref("")

const copy = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
        toast({
                component: MyToast,
                props: {
                    title: 'Корзина сохранена',
                    detail: 'Ссылка на корзину добавлена в буфер обмена',
                }
            },
            {
                timeout: 5000
            })
    })
}
const saveCart = async () => {
    const response = await privateAxios.post<any>('/user/cart-save')
    if(response.data?.saved_cart_url?.length > 0) {
        savedCartUrl.value = response.data.saved_cart_url
    } else {
        toast({
                component: MyToastError,
                props: {
                    title: 'Ошибка',
                    detail: 'Не удалось сохранить корзину',
                }
            },
            {
                timeout: 3000
            })
    }
}

</script>
